import React from 'react'
import styles from './TopStatCard.module.scss'

interface TopStatCardProps {
  label: string
  value: string | number
  icon?: React.ReactNode
  accentColor?: 'primary' | 'info' | 'success' | 'warning'
  className?: never
}

export const TopStatCard: React.FC<TopStatCardProps> = ({
  label,
  value,
  icon,
  accentColor = 'primary',
}) => (
  <div className={styles.card}>
    {icon && (
      <span className={[styles.iconBubble, styles[`accent_${accentColor}`]].join(' ')}>
        {icon}
      </span>
    )}
    <span className={styles.value}>
      {typeof value === 'number' ? value.toLocaleString() : value}
    </span>
    <span className={styles.label}>{label}</span>
  </div>
)
